// extracted by mini-css-extract-plugin
module.exports = {"GoBackWrapper":"GoBack_GoBackWrapper__1TcJV","backLink":"GoBack_backLink__2w0dN"};